import { Component, OnInit, ViewChild } from '@angular/core';
import PlaceResult = google.maps.places.PlaceResult;
import { FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { GeneralService } from '../../services/general.service';
import { MatDialog } from '@angular/material';
import { LoginService } from '../../services/auth.service';
import { ThankYouDialogComponent } from '../../dialogs/thank-you-dialog/thank-you-dialog.component';
import { ApiService } from '../../api.service';

@Component({
  selector: 'app-create-ride',
  templateUrl: './create-ride.component.html',
  styleUrls: ['./create-ride.component.scss'],
})
export class CreateRideComponent implements OnInit {
  @ViewChild('fComponent')
  fComponent: any;
  step = 0;
  today: Date;
  fromAddress: any;
  isRequesting: boolean;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  fourthFormGroup: FormGroup;
  fifthFormGroup: FormGroup;
  sixthFormGroup: FormGroup;
  panelOpenState = false;
  opts = { Yes: true, No: false };
  routes = ['One-Way', 'Two-Way'];
  frequentTrips = ['One Off', 'Regular'];
  isSubmitting = false;
  data: any;
  options: any;
  checkPoints: FormArray;

  constructor(
    public api: ApiService,
    private formBuilder: FormBuilder,
    private titleService: Title,
    private router: Router,
    public generalService: GeneralService,
    public dialog: MatDialog,
    public loginService: LoginService,
    private meta: Meta
  ) {}

  ngOnInit() {
    this.options = Object.keys(this.opts);
    // this.data = {} as IndividualTrip;
    // this.today = new Date();
    this.titleService.setTitle(
      'Create a Trip, Share your ride, Request a Lift, get new friends on Matesride by Autoscoop'
    );
    this.meta.updateTag({
      name: 'description',
      content:
        'Create Trip to Canberra, Create trip to Sydney, Create trip to Melbourne, Create trip to Brisbane, Create trip to Adelaid, Create trip to Gold Coast, Create trip to Perth, Create trip to Great Ocean Drive',
    });
    this.meta.updateTag({
      name: 'keywords',
      content:
        'carpooling to Canberra, Carpooling to Melbourne, Carpooling to Sydney, Rideshare , Create ride, Create Trip, Trip Mates, Mates Ride, Rider, Co-rider, Ride Passion, Long Ride, Enjoy ride',
    });
    this.firstFormGroup = this.formBuilder.group({
      hheader: ['', Validators.required],
      intro: [''],
      trip: [''],
    });
    this.secondFormGroup = this.formBuilder.group({
      fromAddress: ['', Validators.required],
      toAddress: ['', Validators.required],
      detailFromAddress: [''],
      detailToAddress: [''],
      detailFrom: [''],
      detailTo: [''],
    });
    this.thirdFormGroup = this.formBuilder.group({
      vehicleType: ['', Validators.required],
      rego: ['', Validators.required],
      regoState: ['', Validators.required],
      make: ['', Validators.required],
      model: ['', Validators.required],
      seats: ['', Validators.required],
    });
    this.fourthFormGroup = this.formBuilder.group({
      chargeForRide: ['', Validators.required],
      rideCharge: ['0'],
      childChargeable: ['', Validators.required],
      childCharge: ['0'],
      luggage: ['', Validators.required],
      luggaeWeight: ['0'],
    });
    this.fifthFormGroup = this.formBuilder.group({
      startTime: ['', Validators.required],
      arrivalTime: ['', Validators.required],
      pickRDrop: [''],
      enRouteCity: this.formBuilder.array([this.createCheckPoints()]),
      frequentTrip: [''],
      daily: [''],
      regularWeek: [''],
      specificDays: [''],
      shh: ['', Validators.required],
      smm: ['', Validators.required],
      ahh: ['', Validators.required],
      amm: ['', Validators.required],
    });
    this.sixthFormGroup = this.formBuilder.group({
      shareDrive: ['', Validators.required],
      ageLimit: ['', Validators.required],
      age: [''],
      rideExpiry: [''],
      rhh: ['', Validators.required],
      rmm: ['', Validators.required],
      wheelChair: [''],
      musicPrefernce: [''],
      chitChatPreference: [''],
      prefSmokingAllowed: [''],
      prefPetAllowed: [''],
    });
  }

  formDisable() {
    // tslint:disable-next-line:max-line-length
    return !(
      this.firstFormGroup.valid &&
      this.secondFormGroup.valid &&
      this.thirdFormGroup.valid &&
      this.fourthFormGroup.valid &&
      this.fifthFormGroup.valid &&
      this.sixthFormGroup.valid
    );
  }

  submitTripQuote() {
    if (!this.loginService.isAuthenticated()) {
      this.generalService.openSignInDialog(
        'Before submitting the form, you need to login.'
      );
    } else {
      this.isSubmitting = true;
      this.data = {
        ...this.firstFormGroup.value,
        ...this.secondFormGroup.value,
        ...this.thirdFormGroup.value,
        ...this.fourthFormGroup.value,
        ...this.fifthFormGroup.value,
        ...this.sixthFormGroup.value,
      };
      this.data.idp = this.loginService.getuser_id();
      // console.log(this.data);
      this.api.createRide(this.data).subscribe(
        r => {
          console.log(r);
          // this.generalService.trackEvent('Request', 'quote', 'trip');
          this.isSubmitting = false;
          const dialogRef = this.dialog.open(ThankYouDialogComponent, {
            width: '400px',
            data: {
              body: 'Track request to join your trip in Profile page',
              rideId: r.rideId,
            },
          });

          dialogRef.afterClosed().subscribe(result => {
            this.router.navigate(['/']);
          });
        },
        error => {
          console.log(error);
          this.isSubmitting = false;
        }
      );
    }
  }

  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  createCheckPoints(): FormGroup {
    return this.formBuilder.group({
      boardPoint: ['', Validators.required],
      arrTime: ['', Validators.required],
      hh: ['', Validators.required],
      mm: ['', Validators.required],
    });
  }

  get formBoardingpoints() {
    return this.fifthFormGroup.get('enRouteCity') as FormArray;
  }

  addCheckPoints() {
    this.checkPoints = this.fifthFormGroup.controls.enRouteCity as FormArray;
    this.checkPoints.push(this.createCheckPoints());
  }

  removeCheckPoints(i: number) {
    this.checkPoints = this.fifthFormGroup.controls.enRouteCity as FormArray;
    this.checkPoints.removeAt(i);
  }
}
